import {Component, ComponentRef, Input, OnInit, ViewChild, ViewContainerRef} from '@angular/core';
import { GroupFilterModel } from '../../shared/pipes/FilterByNameAndGroup.pipe';
import {BaseDialog} from "../BaseDialog";
import {IManagableObject} from "../IManagableObject";
import { ObjectGroupViewModel } from '../ObjectGroupViewModel';

declare const $;

@Component({
    selector: 'app-objects-management-dialog',
    templateUrl: './objects-management-dialog.component.html',
    styleUrls: ['./objects-management-dialog.component.css'],
    standalone: false
})
export class ObjectsManagementDialogComponent extends BaseDialog implements OnInit {
  public filter: GroupFilterModel = new GroupFilterModel();

  @Input() public isSingleItem: boolean = false;
  @Input() public groups: ObjectGroupViewModel[] = [];
  @Input() public title = "Objects list";

  public selectGroup(group: ObjectGroupViewModel) {
    this.filter.group = group;
    setTimeout(function () { $(".dropclick").removeClass("opened"); }, 100);
  }
  public onTermChange(event: Event) {
    const input = event.target as HTMLInputElement;
    this.filter.term = input.value;
  }

  onToggle(val: IManagableObject) {
    if (this.isSingleItem)
    {
      const checked = val.IsChecked;
      this.objects.filter(o => o.Id != val.Id).forEach(value => value.IsChecked = false);
      this.selectObjectsCount = checked ? 1 : 0;
    }
    else
      super.onToggle(val);
  }
}
